import styled from 'styled-components'
import { COLORS } from 'consts/colors'
import { SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'
import { SHADOWS } from 'styles/consts'
import { Z_INDEX_FOR_HIDE_REACT_SELECTO_RECTANGLE_DURING_SCROLL } from 'consts/zIndex'
export const AppContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
`

export const EditorLayout = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  overflow: hidden;
  /* Light gutter + uniform gaps behind the floating shell panels. */
  background-color: ${COLORS.gutter};
  padding: 8px;
  gap: 8px;
  box-sizing: border-box;
  @media only screen and (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    flex-direction: column-reverse;
    /* Mobile keeps the pre-redesign full-bleed structure — no floating cards. */
    padding: 0;
    gap: 0;
  }
`

export const Content = styled.main`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: hidden;
  /* Grey behind the rounded Header/Timeline cards so their corners don't
     reveal white wedges. */
  background-color: ${COLORS.fill};
  border-radius: 16px;
  box-shadow: ${SHADOWS.panel};
  @media only screen and (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    border-radius: 0;
    box-shadow: none;
  }
`

export const MainContent = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  overflow: hidden;
  z-index: ${Z_INDEX_FOR_HIDE_REACT_SELECTO_RECTANGLE_DURING_SCROLL};
`

export const CanvasArea = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  width: 100%;
  height: 100%;
  overflow: hidden;
`
